(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["QQ-Hero"] && !window.DesignMode) return;
  try {
    "use strict";function _typeof(e){return(_typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}!function(){function t(){var e=document.querySelectorAll(".qq-hero-slider .QQ-JS-init-msg");e&&e.forEach(function(e){e.remove()})}var i;function n(){(i=document.getElementsByClassName("qq-hero-slider")).length&&function e(){{var t,i,n;null==("undefined"==typeof $?"undefined":_typeof($))||null==window.$?((t=document.createElement("script")).id="qq-jquery",document.head.appendChild(t),t.type="text/javascript",t.src="https://code.jquery.com/jquery-3.6.0.min.js",t.onload=function(){e()}):document.getElementById("qq-slick")&&document.getElementById("qq-slick-css")?i=setInterval(function(){$.fn.slick&&(clearInterval(i),o())},10):(document.getElementById("qq-slick")||((n=document.createElement("script")).id="qq-slick",document.head.appendChild(n),n.type="text/javascript",n.src="https://cdn.jsdelivr.net/npm/slick-slider@1.8.1/slick/slick.min.js",n.onload=function(){e()}),document.getElementById("qq-slick-css")||((n=document.createElement("link")).id="qq-slick-css",document.head.appendChild(n),n.type="text/css",n.rel="stylesheet",n.href="https://cdn.jsdelivr.net/npm/slick-slider@1.8.1/slick/slick.css"))}}()}function o(){for(var e=0;e<i.length;e++)!function(e){{var n,t,s,i,o,l,d,r,a,c,u,p,f,m,q,h,y,v,g;$("#"+e).length&&(n=function(){var e,t,i=p.parent();p.length&&(e=s.outerHeight(!0),t=(t="0"==(t=($(window).width()<799&&0<s.find(".slick-current img.qq-mobile").length?s.find(".slick-current img.qq-mobile"):s.find(".slick-current img")).outerHeight(!0))?e:t)/2-p.outerHeight(!0)/2,p.add(f).css("top",t),t=s.find(".qq-slide").length,i.hasClass("qq-hidden")&&1<t&&i.removeClass("qq-hidden"))},t=function(){var e,t,i,n,o;$(window).width()<799&&(t=(e=s.find("ul.slick-dots")).outerHeight(!0),i=Number(s.attr("data-dotsMobileTopMargin")),void 0!==(o=s.attr("data-sliderDotsPositionMobile"))?(console.log("sliderDotsPosition: ",o),o=void 0===(o=s.find(".qq-slide-wrapper"))||0===o.length?(n="bottom",i):(n="top",o.position().top-t-i),e.css(n,+o+"px")):e.css("bottom","-"+(t+i)+"px"))},$("#"+e),s=$("#"+e).find(".qq-slides"),i=Number(s.attr("data-sliderSlidesToShow")),o=Number(s.attr("data-sliderSlidesToShowMobile")),l=/true/i.test(s.attr("data-sliderAutoplay")),d=1e3*Number(s.attr("data-sliderSpeed")),r=Boolean(s.attr("data-sliderInfinite")),v=s.attr("data-sliderAnimation"),a=s.attr("data-sliderNavigation"),p=$("#"+e+" span.qq-slider-prev"),f=$("#"+e+" span.qq-slider-next"),c=s.attr("data-sectionCustomHeight"),s.find(".qq-slide-text"),self["sliderContent"+e]&&self["sliderContent"+e].slick("unslick"),$("#"+e+" .qq-slider-slider-items"),"dots"==a?u=!(m=!0):"none"==a?u=m=!1:(u=!0,p=$("#"+e+" span.qq-carousel-prev"),f=$("#"+e+" span.qq-carousel-next"),m="both"==a),q=!1,y=$("html").attr("dir"),h=$("html").css("direction"),(null!=y&&"rtl"==y||null!=_typeof(h)&&"rtl"==h)&&(q=!0,null==y&&$("html").attr("dir","rtl")),console.log("rtl: ",q),y=1==i&&"fade"==v?!0:!1,v=1==o&&"fade"==v,self["sliderContent"+e]=$("#"+e+" .qq-slides").not(".slick-initialized").on("init reInit setPosition",function(){clearInterval(g),g=setTimeout(function(){"both"==a?(t(),n()):"dots"==a?t():"arrows"==a&&n()},500)}).slick({loop:!0,slidesToShow:i,slidesToScroll:1,infinite:r,swipeToSlide:!0,adaptiveHeight:!!c,rtl:q,arrows:u,dots:m,fade:y,rows:0,prevArrow:p,nextArrow:f,autoplay:l,autoplaySpeed:l?d:void 0,centerMode:!1,focusOnSelect:!0,responsive:[{breakpoint:768,settings:{slidesToShow:o,fade:v}}]}),s.on("afterChange",function(e,t,i){n()}))}}("qq"+i[e].id.replace("template--","").replace("shopify-section-","").replace("__",""))}window.addEventListener("shopify:section:load",function(e){t()}),t(),"loading"!==document.readyState?n():document.addEventListener("DOMContentLoaded",function(){n()}),window.addEventListener("shopify:section:load",function(e){n()}),window.addEventListener("shopify:block:select",function(o){if(i.length)for(var e=0;e<i.length;e++)!function(e){var e=i[e].id,n="qq"+e.replace("template--","").replace("shopify-section-","").replace("__","");"shopify-section-"+o.detail.sectionId===e&&setTimeout(function(e){var t=$("#"+n+" .slick-slider"),i=$("#"+n+' .qq-slide[data-shopify-editor-block=\'{"id":"'+o.detail.blockId+'","type":"slide"}\']').attr("data-slick-index");t.slick("slickGoTo",Number(i),!0)},100,e)}(e)})}();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["QQ-TextBlock"] && !window.DesignMode) return;
  try {
    "use strict";!function(){function t(){var e=document.querySelectorAll(".qq-images-marquee .QQ-JS-init-msg");e&&e.forEach(function(e){e.remove()})}var m,c,l;function n(){(m=document.getElementsByClassName("qq-images-marquee")).length&&function(){if(c=[],m.length)for(var e,t,i,o,n=0;n<m.length;n++)!function(n){e=m[n].id,t="qq"+e.replace("template--","").replace("shopify-section-","").replace("__",""),i=document.getElementById(t).getElementsByClassName("qq-marquee-images")[0],o=i.getElementsByClassName("qq-block-image"),c[n]=new Object,c[n].sectionID=t,c[n].wrapper=i,c[n].imgs=o,c[n].imgsCntr=0,[].forEach.call(o,function(e,t){e.complete?(c[n].imgsCntr++,a(n)):e.addEventListener("load",function(e){c[n].imgsCntr++,a(n)})})}(n);function a(e){c[e].imgsCntr==c[e].imgs.length&&r(c[e])}function r(n){var e=document.getElementById(n.sectionID).getElementsByClassName("qq-marquee-images").length,t=n.wrapper.offsetWidth;l=window.innerWidth;var i=Math.ceil(l/t)+1,o=1,a=!0;if(document.querySelector(":root").style.setProperty("--"+n.sectionID+"-imagesMarquee-length","-"+t+"px"),e<i?i-=e:i<=e&&(a=!1),1==a)for(;o<=i;){var r=n.wrapper.cloneNode(!0);n.wrapper.parentNode.append(r),[].forEach.call(r.getElementsByClassName("qq-block-image"),function(e,t){e.width=n.imgs[t].width,e.height=n.imgs[t].height}),o++}setTimeout(function(e){e.wrapper.parentNode.classList.add("qq-animate")},1e3,n)}var s;window.onresize=function(){clearTimeout(s),l!=window.innerWidth&&(console.log("resizing"),l=window.innerWidth,s=setTimeout(function(){for(var e=0;e<c.length;e++){var t=document.getElementById(c[e].sectionID).getElementsByClassName("qq-marquee-images"),n=t.length;if(1<n)for(var i=n-1;0<i;i--)t[i]&&t[i].remove();t[0].parentNode.classList.remove("qq-animate"),r(c[e])}},500))}}()}window.addEventListener("shopify:section:load",function(e){t()}),t(),"loading"!==document.readyState?n():document.addEventListener("DOMContentLoaded",function(){n()}),window.addEventListener("shopify:section:load",function(e){n()})}();
  } catch(e) { console.error(e); }
})();

})();
